module.exports = __webpack_public_path__ + "media/images/queue_icon-fa145cf54f2d2014bf987213e67e5d0f.svg";